export const THEME_KEY = 'app_theme'
export const DEFAULT_THEME = 'light'

export const THEME_LIST = [
  {value: 'light', label: '白天模式', icon: 'el-icon-sunny'},
  {value: 'dark', label: '黑夜模式', icon: 'el-icon-moon'},
  {value: 'eye', label: '护眼模式', icon: 'el-icon-view'},
]

const MENU_THEME_MAP = {
  light: {
    menuBg: '#0f172a',
    menuText: 'rgba(255, 255, 255, 0.72)',
    menuActiveText: '#ffffff',
    subMenuBg: '#1e293b',
  },
  dark: {
    menuBg: '#070b14',
    menuText: 'rgba(255, 255, 255, 0.68)',
    menuActiveText: '#ffffff',
    subMenuBg: '#111827',
  },
  eye: {
    menuBg: '#2f4f3a',
    menuText: 'rgba(255, 255, 255, 0.82)',
    menuActiveText: '#ffffff',
    subMenuBg: '#3d6349',
  },
}

export function isValidTheme(theme) {
  return THEME_LIST.some(item => item.value === theme)
}

export function applyTheme(theme) {
  const next = isValidTheme(theme) ? theme : DEFAULT_THEME
  document.documentElement.setAttribute('data-theme', next)
  localStorage.setItem(THEME_KEY, next)
  return next
}

export function initTheme() {
  return applyTheme(localStorage.getItem(THEME_KEY) || DEFAULT_THEME)
}

export function getMenuTheme(theme) {
  return MENU_THEME_MAP[theme] || MENU_THEME_MAP[DEFAULT_THEME]
}

export function preserveThemeOnStorageClear() {
  const theme = localStorage.getItem(THEME_KEY)
  localStorage.clear()
  if (theme) {
    localStorage.setItem(THEME_KEY, theme)
    applyTheme(theme)
  }
}

export function getThemeOption(theme) {
  return THEME_LIST.find(item => item.value === theme) || THEME_LIST[0]
}
